import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DataService } from '../../../@core/services/data.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HeroBackgroundImageInterface } from '../../../@core/models/site-data.model';
import { MatDialog } from '@angular/material/dialog';
import * as Sentry from "@sentry/browser";
import { FontsService } from 'src/app/@core/services/fonts.service';
declare var DePayWidgets: any;


@Component({
  selector: 'app-material-hero-background-image',
  templateUrl: './hero-background-image.component.html',
  styleUrls: ['./hero-background-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialHeroBackgroundImageComponent implements OnInit, OnDestroy {
  title$: BehaviorSubject<string> = new BehaviorSubject('');
  height: number = 700;
  style: string;
  text: string;
  picture: string[];
  buttonText: string = 'Get Started';
  dePayWidgetsId: string;
  buttonLink: string;
  activatePadding: boolean = false;
  titleSize: string;
  fontWeight: string;
  lineHeight: string;
  backgroundPosition: string = '';
  containerAlignment: string = '';
  textAlignment: string = '';
  secondButtonText: string;
  secondButtonLink: string;
  buttonsDisplay: number;
  subscription: Subscription;
  data: HeroBackgroundImageInterface;
  position: number = 0;
  moduleInfo: string;
  isStock: string = '';
  siteId: string = '';
  texst: string = '';
  sliderIndex: number = -1;
  timeOut;
  allElementAnimation: string;
  textAnimation: string;
  buttonAnimation: string;
  loading: boolean = true;
  buttonIcon: string = '';
  secondaryButtonIcon: string = '';
  buttonStyle: string = '';
  buttonBackgroundColor: string = '';
  buttonTextColor: string = '';
  titleFontFamily: string;
  titleFontFamilyName: string;

  constructor(private dataService: DataService, private _cdr: ChangeDetectorRef, private dialog: MatDialog,private fontsService:FontsService) {
  }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.buttonAnimation = this.data.animation.button != '' ? this.data.animation.button : undefined;

    }
    this.loading = false;
    if (this.data.typingEffect) {

      let i = 0;
      let speed = 180;
      const typeWriter = () => {
        if (this.data.title.includes('<br>') || this.data.title.includes('</br>')) {
          if (i < this.data.title.length) {
            if (this.data.title.charAt(i) != '<') {
              let string = this.title$.getValue();
              string += this.data.title.charAt(i);
              this.title$.next(string);
            } else {
              if (this.data.title.includes('<br>')) {
                let string = this.title$.getValue();
                string += '<br>';
                this.title$.next(string);
                i += 3;
              } else {
                let string = this.title$.getValue();
                string += '</br>';
                this.title$.next(string);
                i += 4;
              }
            }
            i++;
            setTimeout(typeWriter, speed);
          }
        }
        else {
          if (i < this.data.title.length) {
            let string = this.title$.getValue();
            string += this.data.title.charAt(i);
            this.title$.next(string);
            i++;
            setTimeout(typeWriter, speed);
          }
        }
      }
      typeWriter()
    }
    else {
      this.title$.next(this.data.title)
    }
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "HeroImageComponent");
    });
    this.subscription = this.dataService.getSiteId().subscribe(siteId => {
      this.siteId = siteId;
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.height = this.data.height;
    this.text = this.data.text;
    this.picture = this.data.image;
    this.dePayWidgetsId = this.data.dePayWidgetsId;
    this.buttonText = this.data.buttonText;
    this.buttonLink = this.data.buttonLink;
    this.secondButtonText = this.data.secondButtonText;
    this.secondButtonLink = this.data.secondButtonLink;
    this.buttonsDisplay = this.data.buttonsDisplay;
    this.isStock = this.data.isStock;
    this.fontWeight = this.data.fontWeight;
    this.buttonIcon = this.data.buttonIcon;
    this.secondaryButtonIcon = this.data.secondaryButtonIcon;
    this.secondaryButtonIcon = this.data.secondaryButtonIcon;
    this.buttonBackgroundColor = this.data.buttonBackgroundColor;
    this.buttonTextColor = this.data.buttonTextColor;
    this.buttonStyle = this.data.buttonStyle;
    this.lineHeight = this.data.lineHeight;
    this.titleSize = this.data.titleSize;
    this.backgroundPosition = this.data.backgroundPosition;
    this.containerAlignment = this.data.containerAlignment;
    this.textAlignment = this.data.textAlignment;
    if (this.buttonStyle == 'style3') {
      window.document.body.style.setProperty(
        "--button-background-hero",
        this.buttonBackgroundColor
      );
      window.document.body.style.setProperty(
        "--button-color-hero-video",
        this.buttonTextColor
      );
    } else if (this.buttonStyle == 'style2') {
      window.document.body.style.setProperty(
        "--button-background-hero-video",
        this.buttonTextColor
      );
      window.document.body.style.setProperty(
        "--button-color-hero-video",
        this.buttonBackgroundColor
      );
    }
    this.sliderBackgroundImage();
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
  }

  updateUrl($event) {
    const src = $event.target.src;
    $event.target.src = 'https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/gallery/loading.gif';
    setTimeout(() => {
      $event.target.src = src;
    }, 8000);
  }
  sliderBackgroundImage() {
    if (typeof this.picture == 'string') {
      this.picture = [this.picture];
      this.style = `url("${this.picture}")`;
    } else {
      this.picture;
      if (this.picture.length == this.sliderIndex + 1) {
        this.sliderIndex = -1
      }
      this.sliderIndex = this.sliderIndex + 1;
      if (this.picture) {
        this.style = `url("${this.picture[this.sliderIndex]}")`;
      }
      this._cdr.detectChanges();
      if (this.picture.length > 1) {
        this.timeOut = setTimeout(() => {
          this.sliderBackgroundImage();
        }, 5000);
      }
    }
  }
  nextSliderClick(index: number) {
    this.sliderIndex = index;
    if (this.picture) {
      this.style = `url("${this.picture[this.sliderIndex]}")`;;
    }
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => {
      this.sliderBackgroundImage();
    }, 6000);
  }
  navigateTo(fragment: string) {
    if (fragment) {
      fragment = fragment.replace('/#', '')
      setTimeout(() => {
        if (document.getElementById(fragment)) {
          document.getElementById(fragment).scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  openPay(){
    if(this.data.dePayWidgetsId){
      const config: any = {
        versionCheck: false,
        integration: this.data.dePayWidgetsId
      }
      DePayWidgets.Payment(config);
    }
  }
}
